import {NgModule} from '@angular/core';
import {CREELS} from '@infrastructure/http/creel/creels';
import {HttpCreelsService} from '@infrastructure/http/creel/http-creels.service';
import {HttpMachineOverviewService} from '@infrastructure/http/machine-overview/http-machine-overview.service';
import {MACHINE_OVERVIEW} from '@infrastructure/http/machine-overview/machine-overview';
import {HttpPlanningService} from '@infrastructure/http/planning/http-planning.service';
import {PLANNING} from '@infrastructure/http/planning/planning';
import {HttpProductionOrdersWeavingService} from '@infrastructure/http/production-order-weaving/http-production-orders-weaving.service';
import {PRODUCTION_ORDERS_WEAVING} from '@infrastructure/http/production-order-weaving/production-orders-weaving';
import {HttpProductionOrdersService} from '@infrastructure/http/production-order/http-production-orders.service';
import {PRODUCTION_ORDERS} from '@infrastructure/http/production-order/production-orders';
import {HttpProductionSchedulesService} from '@infrastructure/http/production-schedule/http-production-schedules.service';
import {PRODUCTION_SCHEDULES} from '@infrastructure/http/production-schedule/production-schedules';
import {HttpWeaveProductsService} from '@infrastructure/http/weave-product/http-weave-products.service';
import {WEAVE_PRODUCT} from '@infrastructure/http/weave-product/weave-products.interface';
import {REALTIME_PLANNING} from '@infrastructure/signalr/planning/realtime-planning';
import {SignalrPlanningService} from '@infrastructure/signalr/planning/signalr-planning.service';
import {REALTIME_PRODUCTION_ORDER_LITE} from '@infrastructure/signalr/production-order-lite/realtime-production-order-lite';
import {SignalrProductionOrderLiteService} from '@infrastructure/signalr/production-order-lite/signalr-production-order-lite.service';
import {REALTIME_PRODUCTION_ORDER} from '@infrastructure/signalr/production-order/realtime-production-order';
import {SignalrProductionOrderService} from '@infrastructure/signalr/production-order/signalr-production-order.service';
import {SharedModule} from '@shared/shared.module';
import {DelayedClassModule, PlanningDisplayModule, PlanningDragDropModule, SelectionListContainerModule, SelectionListModule} from '@vdw/angular-component-library';
import {ProductionScheduleSharedModule} from '../production-schedule/production-schedule-shared.module';

import {ConfirmProductionOrderDeletionCommand} from './confirm-production-order-deletion/confirm-production-order-deletion-command';
import {MachineFilterSettingsComponent} from './machine-filter-settings/machine-filter-settings.component';
import {PlanningDisplayContentComponent} from './planning-display-content/planning-display-content.component';
import {PlanningInactivitiyCardComponent} from './planning-inactivitiy-card/planning-inactivitiy-card.component';
import {PlanningOrderCardComponent} from './planning-order-card/planning-order-card.component';
import {PlanningSmallOrderCardInfoComponent} from './planning-order-card/planning-small-order-card-info/planning-small-order-card-info.component';

import {PLANNING_SCHEDULER} from './planning-scheduler/planning-scheduler';
import {PlanningSchedulerService} from './planning-scheduler/planning-scheduler.service';
import {PlanningContextService} from './planning-services/planning-context.service';
import {PlanningDragDropChangesService} from './planning-services/planning-drag-drop-changes.service';
import {PlanningOnboardingService} from './planning-services/planning-onboarding.service';
import {PlanningRealtimeChangesService} from './planning-services/planning-realtime-changes.service';
import {PlanningComponent} from './planning.component';
import {planningRouting} from './planning.routing';
import {ShowProductionOrderIncompatibleWithMachineAlertCommand} from './show-production-order-incompatible-with-machine-alert/show-production-order-incompatible-with-machine-alert-command';
import {MachineDetailSidebarComponent} from './sidebars/machine-detail-sidebar/machine-detail-sidebar.component';
import {NeedsAttentionSidebarComponent} from './sidebars/needs-attention-sidebar/needs-attention-sidebar.component';
import {OrderInfoComponent} from './sidebars/needs-attention-sidebar/order-info/order-info.component';
import {PlannedOrderCardComponent} from './sidebars/needs-attention-sidebar/planned-order-card/planned-order-card.component';
import {UnplannedOrderCardComponent} from './sidebars/needs-attention-sidebar/unplanned-order-card/unplanned-order-card.component';
import {PlanningItemDetailsComponent} from './sidebars/planning-item-sidebar/planning-item-details/planning-item-details.component';
import {ColoredYarnSetMapCardComponent} from './sidebars/planning-item-sidebar/planning-item-form/edit-creel-mapping/colored-yarn-set-map-card/colored-yarn-set-map-card.component';
import {EditCreelMappingComponent} from './sidebars/planning-item-sidebar/planning-item-form/edit-creel-mapping/edit-creel-mapping.component';
import {PlanningItemFormComponent} from './sidebars/planning-item-sidebar/planning-item-form/planning-item-form.component';
import {PlanningItemSidebarComponent} from './sidebars/planning-item-sidebar/planning-item-sidebar.component';
import {ProductionOrdersListComponent} from './sidebars/planning-item-sidebar/production-orders-list/production-orders-list.component';
import {SelectProductionOrderComponent} from './sidebars/planning-item-sidebar/production-orders-list/select-production-order/select-production-order.component';
import {PlanningOrderDetailSidebarComponent} from './sidebars/planning-order-detail-sidebar/planning-order-detail-sidebar.component';
import {PlanningSidebarsComponent} from './sidebars/planning-sidebars.component';

@NgModule({
  imports: [SharedModule, planningRouting, ProductionScheduleSharedModule, PlanningDisplayModule, PlanningDragDropModule, SelectionListModule, SelectionListContainerModule, DelayedClassModule],
  providers: [
    {
      provide: PLANNING,
      useClass: HttpPlanningService
    },
    {
      provide: PLANNING_SCHEDULER,
      useClass: PlanningSchedulerService
    },
    {
      provide: MACHINE_OVERVIEW,
      useClass: HttpMachineOverviewService
    },
    {
      provide: PRODUCTION_ORDERS,
      useClass: HttpProductionOrdersService
    },
    {
      provide: REALTIME_PLANNING,
      useClass: SignalrPlanningService
    },
    {
      provide: REALTIME_PRODUCTION_ORDER,
      useClass: SignalrProductionOrderService
    },
    {
      provide: REALTIME_PRODUCTION_ORDER_LITE,
      useClass: SignalrProductionOrderLiteService
    },
    {
      provide: CREELS,
      useClass: HttpCreelsService
    },
    {
      provide: PRODUCTION_SCHEDULES,
      useClass: HttpProductionSchedulesService
    },
    {
      provide: PRODUCTION_ORDERS_WEAVING,
      useClass: HttpProductionOrdersWeavingService
    },
    {
      provide: WEAVE_PRODUCT,
      useClass: HttpWeaveProductsService
    },
    PlanningContextService,
    PlanningOnboardingService,
    ConfirmProductionOrderDeletionCommand,
    PlanningRealtimeChangesService,
    PlanningDragDropChangesService,
    ShowProductionOrderIncompatibleWithMachineAlertCommand
  ],
  declarations: [
    ColoredYarnSetMapCardComponent,
    EditCreelMappingComponent,
    MachineDetailSidebarComponent,
    NeedsAttentionSidebarComponent,
    OrderInfoComponent,
    PlannedOrderCardComponent,
    PlanningItemDetailsComponent,
    PlanningItemFormComponent,
    PlanningItemSidebarComponent,
    PlanningOrderDetailSidebarComponent,
    ProductionOrdersListComponent,
    SelectProductionOrderComponent,
    UnplannedOrderCardComponent,
    PlanningComponent,
    PlanningDisplayContentComponent,
    PlanningSidebarsComponent,
    PlanningOrderCardComponent,
    PlanningInactivitiyCardComponent,
    PlanningSmallOrderCardInfoComponent,
    PlanningOrderCardComponent,
    MachineFilterSettingsComponent
  ],
  exports: [NeedsAttentionSidebarComponent, MachineDetailSidebarComponent, PlanningItemSidebarComponent, PlanningOrderDetailSidebarComponent]
})
export class PlanningModule {}
